var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},[React.createElement("path",{"d":"M34.8704 11.3232L54.5305 30.9833C56.4831 32.9359 56.4831 36.1017 54.5305 38.0543L38.3022 54.2826C36.3496 56.2352 33.1837 56.2352 31.2311 54.2826L11.5711 34.6226C10.5506 33.6021 10.0209 32.1906 10.1179 30.7507L11.1429 15.5474C11.3111 13.051 13.2988 11.0633 15.7952 10.895L30.9986 9.87007C32.4384 9.773 33.85 10.3028 34.8704 11.3232Z","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("circle",{"cx":"21.2773","cy":"20.5659","r":"1","stroke":"currentColor","strokeWidth":"2","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"64","height":"64","fill":"currentColor","transform":"translate(0 0.00878906)"})))]);
}

SVGIcon.defaultProps = {"viewBox":"0 0 64 65"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
